<ng-container *transloco="let t">
  @let advertiser = dspAdvertiser();
  @if (
    !!advertiser &&
    (advertiser.bidderOrganizationId === undefined || advertiser.bidderOrganizationId !== organizationId())
  ) {
    <div class="m-4">
      <IAlert type="warning" [title]="t('dsp-manager.dsp_full_automation_not_activated_title')">
        <div>
          {{ t("dsp-manager.dsp_full_automation_message_1") }}
          <a
            class="text-main-500 hover:text-main-600 cursor-pointer"
            routerLink="/accounts"
            queryParamsHandling="merge"
            >{{ t("page-title.accounts") }}</a
          >
          {{ t("dsp-manager.dsp_full_automation_message_2") }}
        </div>
      </IAlert>
    </div>
  } @else {
    @if (dspAdvertiserIsNotApproved()) {
      <div class="mx-4 mt-4">
        <IAlert type="warning" [title]="t('dsp-manager.dsp_advertiser_not_approved_title')">
          <div>
            {{ t("dsp-manager.dsp_advertiser_not_approved_message") }}
          </div>
        </IAlert>
      </div>
    }
    <app-strategy-list />
  }
</ng-container>
